export default "__VITE_ASSET__780d5Eab__"